import { isWeb } from "@memorang/helpers/platform";
/* -----------------UI--------------- */
import { Dialog, IconButton, Portal } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { ToastProvider } from "../Toast";

type Props = {
	visible: boolean;
	handleClose?: () => void;
	children: React.ReactNode;
	maxWidth?: unknown;
	showCloseButton?: boolean;
	height?: `${number}%` | number;
	bottom?: number;
	minHeight?: number | `${number}%`;
	width?: number | `${number}%`;
};
const DialogWrapper = ({
	visible,
	handleClose,
	children,
	bottom,
	height,
	minHeight,
	width = "80%",
	showCloseButton,
}: Props) => {
	const theme = useAppTheme();
	return (
		<Portal>
			<Dialog
				visible={visible}
				onDismiss={handleClose}
				style={{
					width,
					alignSelf: "center",
					bottom: bottom || 0,
					height,
					minHeight,
					overflow: "hidden",
					maxHeight: isWeb ? "90%" : undefined,
					...theme.componentOverrides.dialog,
				}}
			>
				<ToastProvider>{children}</ToastProvider>
				{showCloseButton && (
					<Box position="absolute" top={12} right={12}>
						<IconButton icon="close" onPress={handleClose} />
					</Box>
				)}
			</Dialog>
		</Portal>
	);
};

export default DialogWrapper;
